import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '../styled';
var expansionPanelDetailsComponentName = 'QuantumExpansionPanelDetails';
export var ExpansionPanelDetails = styled(AccordionDetails, {
    name: expansionPanelDetailsComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme;
    return {
        display: 'flex',
        padding: 0,
        marginTop: theme.spacing(3),
        flexDirection: 'column',
    };
});
